import * as React from 'react';
import { SvgComponentProps, Svg } from './svg-component';

export const RefreshIcon = ({ size, ...rest }: SvgComponentProps) => (
    <Svg width={size || 48} height={size || 48} viewBox="0 0 48 48" fill="none" {...rest}>
        <path
            d="m37.291 30.648 6.648-1.666L45.6 35.63"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M43.258 29.155A20.016 20.016 0 0 1 24 43.94 20.02 20.02 0 0 1 5.28 30.811"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.709 17.352 4.06 19.018 2.4 12.37"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.742 18.845A20.016 20.016 0 0 1 24 4.06v0a20.02 20.02 0 0 1 18.72 13.128"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Svg>
);
